import ExcelDownload from "../../../components/ExcelDownload";

function ExcelWallet({ state }) {
  const params = {
    barname: state.barname || undefined,
    company: state.company || undefined,
    fromDate: state.sDateMyPack || undefined,
    toDate: state.eDateMyPack || undefined,
    walletType: state.walletType || undefined,
    isDirect: state.isDirect ? 1 : undefined,
    isExcel: 1,
  };

  return (
    <div className="d-flex flex-wrap  column-gap-3 row-gap-2">
      <ExcelDownload url="/wallet/v1/collector" params={params}>
        دانلود اکسل کیف پول
      </ExcelDownload>

      <ExcelDownload url="/wallet/v1/income/excel" params={params}>
        دانلود اکسل درآمد
      </ExcelDownload>
    </div>
  );
}

export default ExcelWallet;
